<template>
  <form-sections
    :loading="loading"
    :error="error"
    :schema="schema"

    class="vehicles-form-remove"

    @submit="submit"
    @error="failure"
    @change="change"
  >
    <template v-slot:submit>
      Registrar retirada
    </template>
  </form-sections>
</template>

<script>
  import { mapState } from 'vuex';

  import form from '@cordel/helpers/form/mixin';

  import FormSections from '@cordel/components/Form/Sections.vue';

  import payloadGenerator from './Remove/payload';
  import schemaGenerator from './Remove/schema';

  export default {
    name: 'VehiclesFormRemove',
    components: {
      FormSections,
    },
    mixins: [
      form,
    ],
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),
      };
    },
    computed: {
      ...mapState([
        'usedVehicles',
      ]),

      loading() {
        return this.usedVehicles.update.loading;
      },
      error() {
        return this.usedVehicles.update.error;
      },
    },
    mounted() {
      this.$store.dispatch('usedVehicles/clear', { action: 'remove' });
    },
    methods: {
      change(field, value) {
        this.$emit('change', field, value);
      },

      submit() {
        this.$store
          .dispatch('usedVehicles/remove', {
            id: this.id,
            ...this.getJSON(this.payload),
          })
          .then(this.success)
          .catch(this.failure);
      },
      success() {
        this.$emit('success');
      },
      failure(e) {
        this.$emit('failure', e);
      },
    },
  };
</script>

<style lang="scss">
  .vehicles-form-remove {
    .cordel-sections {
      margin: 0;
    }

    .cordel-sections-buttons {
      margin-left: 0;
      margin-right: 0;
      padding-bottom: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';
</style>
